"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHATTokenBalanceOf = exports.getHATTokenTotalSupply = void 0;
const axios_1 = __importDefault(require("axios"));
const config_1 = require("../config");
const getHATTokenTotalSupply = async (chainId) => {
    var _a;
    if (!chainId)
        return 0;
    try {
        const GET_HAT_TOKEN_TOTAL_SUPPLY = `
      query getHATTokenTotalSupply {
        hattokens {
          totalSupply
        }
      }
    `;
        const subgraphResponse = axios_1.default.post(config_1.ChainsConfig[chainId].subgraph, JSON.stringify({
            query: GET_HAT_TOKEN_TOTAL_SUPPLY,
        }), {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const subgraphData = (await subgraphResponse).data;
        if (!subgraphData.data || !((_a = subgraphData.data) === null || _a === void 0 ? void 0 : _a.hattokens))
            return 0;
        return subgraphData.data.hattokens[0].totalSupply;
    }
    catch (error) {
        return 0;
    }
};
exports.getHATTokenTotalSupply = getHATTokenTotalSupply;
const getHATTokenBalanceOf = async (hatHolder, chainId) => {
    var _a;
    if (!hatHolder || !chainId)
        return 0;
    try {
        const GET_HAT_TOKEN_BALANCE_OF = `
      query getHATTokenBalanceOf($hatHolder: String) {
        hatholder(id: $hatHolder) {
          balance
        }
      }
    `;
        const subgraphResponse = axios_1.default.post(config_1.ChainsConfig[chainId].subgraph, JSON.stringify({
            query: GET_HAT_TOKEN_BALANCE_OF,
            variables: { hatHolder: hatHolder.toLowerCase() },
        }), {
            headers: {
                "Content-Type": "application/json",
            },
        });
        const subgraphData = (await subgraphResponse).data;
        if (!subgraphData.data || !((_a = subgraphData.data) === null || _a === void 0 ? void 0 : _a.hatholder))
            return 0;
        return subgraphData.data.hatholder.balance;
    }
    catch (error) {
        return 0;
    }
};
exports.getHATTokenBalanceOf = getHATTokenBalanceOf;
